// App.tsx — route table: public group vs app group (auth + setup gate) (spec §4.5).
import { Route, Routes } from 'react-router-dom';
import { PublicLayout } from './components/PublicLayout';
import { AuthGate, RequireSetup } from './components/AuthGate';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Privacy, Security, Terms } from './pages/legal';
import { NotFound } from './pages/NotFound';
import { Setup } from './pages/app/Setup';
import { Chat } from './pages/app/Chat';
import { Docs } from './pages/app/Docs';
import { Notes } from './pages/app/Notes';
import { Git } from './pages/app/Git';
import { Voice } from './pages/app/Voice';
import { Agents } from './pages/app/Agents';
import { Settings } from './pages/app/Settings';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="terms" element={<Terms />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="security" element={<Security />} />
      </Route>

      <Route path="/app" element={<AuthGate />}>
        <Route
          index
          element={
            <RequireSetup>
              <Chat />
            </RequireSetup>
          }
        />
        <Route
          path="upload"
          element={
            <RequireSetup>
              <Docs />
            </RequireSetup>
          }
        />
        <Route
          path="notes"
          element={
            <RequireSetup>
              <Notes />
            </RequireSetup>
          }
        />
        <Route
          path="git"
          element={
            <RequireSetup>
              <Git />
            </RequireSetup>
          }
        />
        <Route
          path="voice"
          element={
            <RequireSetup>
              <Voice />
            </RequireSetup>
          }
        />
        <Route
          path="agents"
          element={
            <RequireSetup>
              <Agents />
            </RequireSetup>
          }
        />
        <Route
          path="settings"
          element={
            <RequireSetup>
              <Settings />
            </RequireSetup>
          }
        />
        <Route path="setup" element={<Setup />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
